import Vue from 'vue';
/*限流*/
Vue.directive('throttling', {
    // 只调用一次，指令第一次绑定到元素时调用。在这里可以进行一次性的初始化设置。
    bind: function(el, binding) {     //使用inserted会导致 使用v-if控制显隐的按钮导致事件绑定错误
        const { callback, time = 1000 } = binding.value
        el.callback = callback
        el.time = time
        el.addEventListener('click', () => {
            const nowTime = new Date().getTime()
            if (!el.preTime || nowTime - el.preTime > el.time) {
                el.preTime = nowTime
                el.callback()
            }
        })
    },
    update: function(el, binding) {
        console.log('update')
        const { callback, time = 1000} = binding.value
        el.callback = callback
        el.time = time
    }
})


// WEBPACK FOOTER //
// ./src/libs/directives/throttling.js